import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../services/partner.service';
import { SettingService } from '../services/setting.service';
import { Partner } from '../models/partner';
import { ActivatedRoute } from '@angular/router';
import { Category } from '../models/category';

@Component({
  selector: 'app-partners-details',
  templateUrl: './partners-details.component.html',
  styleUrls: ['./partners-details.component.scss']
})
export class PartnersDetailsComponent implements OnInit {
  partner = new Partner();
  categoryId: number;
  relatedPartners: Partner[] = [];
  categoryName: string;
  constructor(
    private partnerService: PartnerService,
    public settingService: SettingService,
    public router: ActivatedRoute
  ) {
    this.reload();
  }

  ngOnInit() {
    this.router.params.subscribe((param: any) => {
      this.partner.Id = param.id;
      this.categoryId = param.catId;
      this.getPartnerDetails();
      this.settingService.currentcategory.subscribe(
        res=> this.categoryName=res
      )
    });
  }

  getPartnerDetails() {
    this.settingService.loading = true;
    this.partnerService
      .getPartnerById(this.partner.Id, this.categoryId,false)
      .subscribe(res => {
        this.partner = res.partner;
        this.relatedPartners = res.relatedPartners;
        this.settingService.loading = false;
      });
  }
  reload() {
    this.settingService.languageEvent.subscribe(res => {
      this.getPartnerDetails();
    });
  }
}
